import type { SVGProps } from "react"

export default function ShareLink(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="13" cy="13" r="13" fill="#999999" />
      <path
        d="M10.8333 14.0833C11.1642 14.5294 11.5813 14.9038 12.0589 15.1837C12.5365 15.4635 13.0647 15.6429 13.6118 15.7109C14.1589 15.779 14.7132 15.7343 15.2423 15.5797C15.7714 15.4251 16.2645 15.1637 16.6917 14.8117L19.2417 12.6451C20.0186 11.8719 20.4517 10.8277 20.4517 9.7434C20.4517 8.6591 20.0186 7.6149 19.2417 6.8417C18.4648 6.0685 17.418 5.6398 16.3335 5.6398C15.2489 5.6398 14.2021 6.0685 13.4253 6.8417L12.1333 7.975"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1667 11.9167C14.8358 11.4706 14.4187 11.0962 13.9411 10.8163C13.4635 10.5365 12.9353 10.3571 12.3882 10.2891C11.8411 10.221 11.2868 10.2657 10.7577 10.4203C10.2286 10.5749 9.73555 10.8363 9.30833 11.1883L6.75833 13.3549C5.98141 14.1281 5.54834 15.1723 5.54834 16.2566C5.54834 17.3409 5.98141 18.3851 6.75833 19.1583C7.53525 19.9315 8.58198 20.3602 9.66654 20.3602C10.7511 20.3602 11.7978 19.9315 12.5747 19.1583L13.8667 18.025"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
